$(document).ready(function () {
  $(".banner_slider .banner_list").slick({
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    adaptiveHeight: true,
  });

  $(".featured_collection_slider .product_list").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 401,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".our-partners-row").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 2,
    autoplay: true,
    rows: 2,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 551,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
  $(".reviews-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  var interval;
  var counter = 0;
  interval = setInterval(function(){
     $(".related-products-slick").slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1360,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 401,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    });
    if($('.related-products-slick').hasClass('slick-initialized')){
       clearInterval(interval);
    }
  }, 1000);
  
$('.testimonial_inner .customer_list').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
  
});


$(".toggle").click(function (j) {
  var dropDown = $(this).closest(".footer__menu").find(".mobile-toggle");
  $(this)
    .closest(".footer__content")
    .find(".mobile-toggle")
    .not(dropDown)
    .slideUp();

  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(this)
      .closest(".footer__content")
      .find(".toggle.active")
      .removeClass("active");
    $(this).addClass("active");
  }

  dropDown.stop(false, true).slideToggle();
  j.preventDefault();
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$(".tab-container").each(function (k, v) {
  $(v).find(".tab_content:first").show();
});

/* if in tab mode */
$("ul.tabs li").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + activeTab)
    .fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent)
    .find(".tab_drawer_heading[rel^='" + activeTab + "']")
    .addClass("d_active");
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + d_activeTab)
    .fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent)
    .find("ul.tabs li[rel^='" + d_activeTab + "']")
    .addClass("active");
});

/* Extra class "tab_last"
   to add border to right side
   of last tab */
$("ul.tabs li").last().addClass("tab_last");
